export const GET_INVITE__REQUEST = 'LINKS_TYPE__GET_INVITE__REQUEST';
export const GET_INVITE__SUCCESS = 'LINKS_TYPE__GET_INVITE__SUCCESS';
export const GET_INVITE__FAILURE = 'LINKS_TYPE__GET_INVITE__FAILURE';
export const SET_INVITE_ID = 'LINKS_TYPE__SET_INVITE_ID';
